import { makeStyles } from '@mui/styles';
import { formatTranslation } from 'intl';
import { CommonTranslationKeys } from 'intl/keys';
import classNames from 'classnames';
import React from 'react';
import { isProcessValue } from 'shared/domain/process/types/model';
import { Tooltip, Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useProcess } from 'store/process';
import { Color } from 'shared/utils/colors';

interface GeneratedProcessIconProps {
  processId: string;
  className?: string;
  style?: { fontSize?: string };
}

interface StylesProps {
  color: string;
}

const useStyles = makeStyles({
  icon: (props: StylesProps) => ({
    backgroundColor: props.color,
    width: '100%',
    height: '100%',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  }),
  processCode: {
    color: '#FFF',
    fontSize: '1rem',
    fontFamily: 'Archivo',
    userSelect: 'none',
    WebkitUserSelect: 'none',
  },
});

const GeneratedProcessIcon = (
  props: GeneratedProcessIconProps
): React.ReactElement | null => {
  const { processId, className, style } = props;

  const resolvedProcessId = isProcessValue(processId)
    ? processId
    : undefined;
  const process = useProcess(resolvedProcessId);
  const classes = useStyles({ color: process?.color ?? Color.iconGray });
  const intl = useIntl();

  if (!process) {
    return null;
  }

  const tooltipMessage = `${formatTranslation(intl, CommonTranslationKeys.process)}: ${process.label}`;

  return (
    <Tooltip title={tooltipMessage}>
      <Box className={classes.icon} key={processId}>
        <span
          className={classNames(classes.processCode, className)}
          style={style}
        >
          {process.code}
        </span>
      </Box>
    </Tooltip>
  );
};

export default GeneratedProcessIcon;
